import { render } from "./About.vue?vue&type=template&id=456489ed"
const script = {}
script.render = render

export default script